
<template>
<div>
  <v-snackbar 
    v-model="toaster.visible"
    :timeout="timeout"
    :color="toaster.color"
    top
  >
    {{ toaster.message }}
  </v-snackbar>
	<v-card class="d-flex flex-column" width="800" height="auto">
    <button @click="closeModal" class="d-flex align-end flex-column">
      <img style="width: 40px" src="../../../../static/images/close-grey.svg" />
    </button>
		<div class="flex-column d-flex">
			<span class="font-weight-black pt-6 pl-12 d-flex flex-column" style="font-size: 14px">Numeros de Urls</span>
			<div style="background: var(--grey-day-030); height: 48px; width: 138px" class="ml-12 mt-4 rounded d-flex justify-space-around align-center">
				<div class="d-flex align-center"
					type="button"
					v-on:click="decreaseCounter"
				>
					<img :src="model.urlsNumber === 1 ? '../../../../static/images/less-grey.svg' : '../../../../static/images/less.svg'" />
				</div>
				<input
					min="1"
					max="5"
					style="background: var(--white); height:	38px; width: 48px"
					class="rounded d-flex justify-center align-center pl-5"
					v-model="model.urlsNumber"
					@input="handleNumber"
				/>
				<div class="d-flex align-center"
					type="button"
					v-on:click="increaseCounter"
				>
					<img :src="model.urlsNumber === 5 ? '../../../../static/images/plus-grey.svg': '../../../../static/images/plus.svg'" />
				</div>
			</div>
			<span class="font-weight-black pt-6 pl-12 d-flex flex-column" style="font-size: 14px">Nome do teste</span>
			<span class="d-flex align-center">
				<input
					placeholder="Insire a URL longa aqui."
          v-on:input="handleValues"
					v-model="model.testeAbName"
					class="mt-3 pl-2 responsive-input-long ml-12 mr-5 rounded" 
					style="border: 2px solid var(--grey-day-020); height: 48px; width: 538px"
					disabled
				>
				<v-btn
					width="152"
					height="48"
					class="mt-2"
					style="background: var(--red); color: var(--white)"
					@click="handleGenerate"
				>
					<img src="../../../../static/images/custom_white.svg"/>
					<span class="pl-3 ff">Gerar Links</span>
				</v-btn>
			</span>
		</div>

		<span v-if="isurlactives">
			<v-sheet
				v-for="(number, index) in model.urlsToShortNumber"
				:key="index"
				class="mt-5 d-flex align-start"
				height="130"
				width="500"
			>
				<div class="rounded borderGreen ml-1 pl-1 mt-1" style="height: 120px; width: 5px !important; background-color: var(--blue);"></div>
				<div class="d-flex flex-row">
					<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url {{number}}
						<span class="d-flex align-center">
							<input
							placeholder="Insira a URL." 
							v-model="urls['url_' + number]"
              @input="handleValues"
              :ref="number"
							class="mt-3 mr-5 pl-2 rounded responsive-n" 
							style="border: 2px solid var(--grey-day-030); height: 48px; width: 450px; background: var(--grey-day-020)"
              required
						>
						</span>
					</span>
					<span class="font-weight-black pt-6 d-flex flex-column" style="font-size: 14px">Valor da importância
						<span class="d-flex align-center">
							<input
								placeholder="Ex.: 60"
								class="mt-3 mr-5 pl-2 rounded responsive-short" 
								style="border: 2px solid var(--grey-day-030); height: 48px; width: 100px;"
                v-model="percs['perc_' + number]"
								type="number"
								id="Urlnumbers"
							>
							<v-btn
								width="120"
								height="48"
								class="mt-3"
								style="background: var(--red); color: var(--white)"
                @click="copyLink(number)"
							>
								<img src="../../../../static/images/square_white.svg"/>
								<span class="pl-3 ff">Copiar</span>
							</v-btn>
						</span>
					</span>
				</div>
			</v-sheet>

			<v-btn
				class="ml-12 mb-5 mt-5"
				width="120"
				height="58"
				color="var(--red)"
				style="color: var(--white)"
				@click="updateTestAB"
        :disabled="!can_save"
			>
				Salvar
			</v-btn>
		</span>
	</v-card>
</div>
	
</template>

<script>
// libs
import { mapActions } from 'vuex';
import VueCookies from 'vue-cookies'

// Mixins
import SplitTest from '../../../mixins/splitTest'

let showCardCreate = false;
let successCreate = false;
let isActive = false;
let testeAbName = "";
let createdUrl = "";

export default {
  mixins: [SplitTest],
  props: ["testeAB", "requestLogs"],
  data() {
    return {
      showCardCreate,
      successCreate,
      isActive,
      createdUrl,
      can_save: false,
      model: {
        urlsNumber: 1,
        urlsToShortNumber: 1,
        testeAbName,
      },
      urls: {
        url_1: "",
        url_2: "",
        url_3: "",
        url_4: "",
        url_5: "",
      },
      percs: {
        perc_1: "",
        perc_2: "",
        perc_3: "",
        perc_4: "",
        perc_5: "",
      },
      isurlactives: true,
      showAlert: false,
      shortUrl: '',
      timeout: 3000,
      toaster: {
        visible: false,
        color: '',
        message: ''
      },
      isShortUrl: false
    };
  },
  mounted () {
    this.model = {
      urlsToShortNumber: this.testeAB.urls.length,
      urlsNumber: this.testeAB.urls.length,
      testeAbName: this.testeAB.name,
    };

    this.testeAB.urls.forEach((url, index) => {
      this.percs["perc_" + (index + 1)] = url.percentage;
      this.urls["url_" + (index + 1)] = url.referenceUrl;
    });

    this.clearVariables;
  },
  updated () {
    this.testeAB
  },
  methods: {
    ...mapActions('SplitTest', [
      'editUrls'
    ]),
    handleAlert() {
      setTimeout(() => {
        this.showAlert = false;
      }, 2000);
    },
    async updateTestAB() {
      const token = VueCookies.get('jwt-login')
      let slug = this.model.testeAbName.toLowerCase().replaceAll(' ', '-');
      let percs = Object.values(this.percs);

      let data = Object.keys(this.urls)
        .filter((item) => this.urls[item])
        .map((item, index) => ({
          referenceUrl: this.urls[item],
          percentage: percs[index],
        }));

      try {
        const response = await this.editUrls([
        {
          test_name: slug,
          urls: data,
        },
        token
        ])

        this.shortUrl = response.shortUrl
        this.isShortUrl = true
        this.toaster.visible = true,
        this.toaster.color = 'var(--green)',
        this.toaster.message = 'Url editada com sucesso'
      }
      catch (error) {
        this.isShortUrl = false
        this.toaster.visible = false,
        this.toaster.color = 'var(--red)',
        this.toaster.message = error.message
      }
    },
    closeModal () {
      this.$emit('close')
    },
    clearForm() {
      this.urls = {
        url_1: "",
        url_2: "",
        url_3: "",
        url_4: "",
        url_5: "",
      };
      this.testeAB.percs = {
        perc_1: "",
        perc_2: "",
        perc_3: "",
        perc_4: "",
        perc_5: "",
      };
      this.isurlactives = false;
      this.model.urlsNumber = 1;
      this.model.testeAbName = "";
    },
    copy () {
      this.$refs.copie
      document.execCommand('copy')
      this.toaster.visible = true,
      this.toaster.color = 'var(--green)',
      this.toaster.message = 'Url Copiada'
    },
    clearVariables() {
      this.showCardCreate = false;
      this.successCreate = false;
      this.isActive = false;
      this.testeAbName = "";
      this.createdUrl = "";

      this.model = {
        testeAbName: "",
        urlsNumber: 1,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
	.v-application {
		font-family: var(--dm-sans-regular);
	}
</style>


// WEBPACK FOOTER //
// src/components/Contents/SplitTest/EditSplitTest.vue